<template>
  <template v-if="dependenciesReport && !loading">
    <vl-title v-if="title" tag-name="h1"> {{ title }} </vl-title>
    <DependencyTable
      v-if="showDeliveryProcessDefinitions"
      entity-type="deliveryprocessdefinition"
      :items="deliveryProcessDefinitions"
      :title="$t('deliveryprocessdefinition.dependencies.deliveryProcessDefinitions.title')"
      :no-results-text="$t('deliveryprocessdefinition.dependencies.deliveryProcessDefinitions.noResults')"
    />
    <DependencyTable
      v-if="showProductProcessDefinitions"
      entity-type="productprocessdefinition"
      :items="productProcessDefinitions"
      :title="$t('deliveryprocessdefinition.dependencies.productProcessDefinitions.title')"
      :no-results-text="$t('deliveryprocessdefinition.dependencies.productProcessDefinitions.noResults')"
    />
    <DependencyTable
      v-if="showProcessTriggers"
      entity-type="processtrigger"
      label-accessor-key="description"
      :items="processTriggers"
      :title="$t('deliveryprocessdefinition.dependencies.processTriggers.title')"
      :no-results-text="$t('deliveryprocessdefinition.dependencies.processTriggers.noResults')"
    />
    <DeliveryRunsTable v-if="showDeliveryRuns" :deliveryRuns="deliveryRuns" />
  </template>
  <template v-if="loading">
    <vl-region>
      <vl-loader :message="$t('deliveryprocessdefinition.dependencies.loading')" />
    </vl-region>
  </template>
</template>
<script lang="ts" setup>
import {
  DeliveryProcessDefinitionBasicDto,
  DeliveryProcessDefinitionDependenciesReportDto,
  DeliveryRunBasicDto,
  ProcessTriggerBasicDto,
  ProductProcessDefinitionBasicDto
} from '@/api/backoffice/clients';
import { useDeliveryProcessDefinitionDetailStore } from '@/modules/configuration/store/delivery-process-definition/delivery-process-definition-detail.store';
import { computed, onMounted, reactive } from 'vue';
import DependencyTable from '@/modules/configuration/views/shared/DependencyTable.vue';
import DeliveryRunsTable from './DeliveryRunsTable.vue';

const store = useDeliveryProcessDefinitionDetailStore();

const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  showDeliveryProcessDefinitions: {
    type: Boolean,
    default: true
  },
  showProductProcessDefinitions: {
    type: Boolean,
    default: true
  },
  showProcessTriggers: {
    type: Boolean,
    default: true
  },
  showDeliveryRuns: {
    type: Boolean,
    default: true
  }
});

const data = reactive({
  isLoading: false
});

const loading = computed(() => {
  return data.isLoading;
});

const dependenciesReport = computed((): DeliveryProcessDefinitionDependenciesReportDto => {
  return store.dependenciesReport;
});

const deliveryProcessDefinitions = computed((): DeliveryProcessDefinitionBasicDto[] => {
  return dependenciesReport.value?.deliveryProcessDefinitions;
});

const productProcessDefinitions = computed((): ProductProcessDefinitionBasicDto[] => {
  return dependenciesReport.value?.productProcessDefinitions;
});

const processTriggers = computed((): ProcessTriggerBasicDto[] => {
  return dependenciesReport.value?.processTriggers;
});

const deliveryRuns = computed((): DeliveryRunBasicDto[] => {
  return dependenciesReport.value?.deliveryRuns;
});

onMounted(async () => {
  data.isLoading = true;
  await store.getDependenciesReport(props.id);
  data.isLoading = false;
});
</script>
<style lang="scss" scoped></style>
